import api from '@/core/api/client';
import type { PlatformBrandingPublicDto } from '@/core/platform-branding/platform-branding';

export type BrandingAssetType = 'logo' | 'logoDark' | 'favicon';

export interface PlatformBrandingStaffResponse {
  id: number;
  platformName: string;
  primaryColor: string;
  logoUrl: string | null;
  faviconUrl: string | null;
  logoUrlDark: string | null;
  accentColor: string | null;
  supportUrl: string | null;
  privacyPolicyUrl: string | null;
  termsOfServiceUrl: string | null;
  updatedAt: string;
  public: PlatformBrandingPublicDto;
}

export type BrandingPatchBody = {
  platformName?: string;
  primaryColor?: string;
  accentColor?: string | null;
  logoUrl?: string | null;
  faviconUrl?: string | null;
  logoUrlDark?: string | null;
  supportUrl?: string | null;
  privacyPolicyUrl?: string | null;
  termsOfServiceUrl?: string | null;
};

export const brandingSettingsService = {
  async get(): Promise<PlatformBrandingStaffResponse> {
    const res = await api.get<PlatformBrandingStaffResponse>('/configuracoes/branding');
    return res.data;
  },

  async patch(body: BrandingPatchBody): Promise<PlatformBrandingStaffResponse> {
    const res = await api.patch<PlatformBrandingStaffResponse>('/configuracoes/branding', body);
    return res.data;
  },

  async upload(
    file: File,
    assetType: BrandingAssetType
  ): Promise<{ success: boolean; url: string; public?: PlatformBrandingPublicDto }> {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('assetType', assetType);
    const res = await api.post('/configuracoes/branding/upload', fd);
    return res.data;
  },
};
